define('home/backbone.overrides',[
    'underscore',
    'backbone',

    'core/api',
    'core/UniqueModel',
], function (
    _,
    Backbone,

    api,
    UniqueModel
) {
    'use strict';
    Backbone.ajax = _.wrap(Backbone.ajax, function (originalAjax, options) {
        // set options.traditional in order to force jQuery to serialize query
        // string parameters according to backend expectations. In other words
        // avoid square brackets in query parameters: b[]=1&b[]=2&b[]=3
        options.traditional = true;

        if (/(?:disqus\.com|dev.disqus.org[^/]*)\/api/.test(options.url))
            return api.call(options.url, options);

        return originalAjax(options);
    });

    /**
     * Creates a sets a related model on this model.
     * Tries to use an existing model, otherwise creates a new model
     * of the given type with the given attributes or id.
     * Looks for the existing model/attributes/id first in the passed
     * options and then in this model's attributes.
     * If no model/attributes/id given, the related model set will
     * be empty.
     *
     * @param  {string} name       - The name of the related model. This
     *                               is the key that will be used to look
     *                               up the data for the related model, and
     *                               will also be the name of the property
     *                               containing the related model
     * @param  {Object} options    - The first place that will be searched
     *                               for the model/attributes/id for the
     *                               related model
     * @param  {class}  ModelClass - The class of the related model
     */
    Backbone.Model.prototype.initializeRelated = function (name, options, ModelClass) {
        var obj = (options && options[name]) || this.get(name);

        if (!obj)
            throw new Error('missing the id, attributes, or model for related model ' + name);

        if (_.isString(obj) || _.isNumber(obj)) {
            var id = obj;
            obj = {};
            obj[ModelClass.prototype.idAttribute || 'id'] = id;
        }

        if (!(obj instanceof ModelClass)) {
            obj = new UniqueModel(
                ModelClass,
                obj,
                options
            );
        }

        // Clear out attributes so we're only storing the data in one place
        this.unset(name);

        this[name] = obj;
    };
});

